import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnInit,
    OnDestroy
} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {UserService} from 'src/app/core/services/user/user.service';
import {StateService} from 'src/app/core/services/state/state.service';
import {TranslateService} from '@ngx-translate/core';
import {RightMatchListService} from '../../../services/right-match-list.service';
import {RightMatchAnalysisService} from '../../../services/right-match-analysis.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {ComponentList} from 'src/app/shared/classes/components/component_list';

@Component({
  selector: 'app-mobile-right-matches-list',
  templateUrl: './mobile-right-matches-list.component.html',
  styleUrls: ['./mobile-right-matches-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MobileRightMatchesListComponent extends ComponentList implements OnInit, OnDestroy {

    analysisTabs = [];

    public orderedBy;
    addAnalysis = false;
    itemToDisplay: any;
    isSelected = 'none';
    selectedTab = 0;
    lastSearch: string;

    private subscriptions = new Subscription();

    constructor(protected router: Router,
                private route: ActivatedRoute,
                private changeDetectorRef: ChangeDetectorRef,  // Even if flagged as unused, it is used in getList(this, search) below
                public user: UserService,
                public stateService: StateService,
                public rightMatchService: RightMatchListService,
                public rightMatch: RightMatchAnalysisService,
                protected translateService: TranslateService,
                protected deviceService: DeviceDetectorService
    ) {
        super(stateService, translateService, router, deviceService);
        if (this.stateService.hasPersonality) {
            this.analysisTabs.push('rightmatch');
        }
        if (this.stateService.hasCommunication) {
            this.analysisTabs.push('idwmatrix');
        }
        if (this.stateService.hasPersonality) {
            this.analysisTabs.push('graphboard');
        }
        if (this.stateService.hasPersonality) {
            this.analysisTabs.push('jobsatisfaction');
        }
        this.orderedBy = this.rightMatchService.state.listColumns.filter(col => col.order !== undefined);
        if (!this.orderedBy.length) {
            this.rightMatchService.state.listColumns.find((col) => {
                if (col.key === 'date') {
                    col.order = 'desc';
                }
            });
        }

        if (!this.stateService.hasPersonality) {
            if (this.stateService.hasCommunication) {
                this.router.navigate(['/m/analysis/idwmatrix/list']).then(() => {});
            } else {
                this.router.navigate(['/m/people/list']).then(() => {});
            }
        }
    }

    ngOnInit() {
        if (!this.rightMatchService.archive) {
            this.setLastAddress();
        }
        this.lastSearch = this.rightMatchService.state.listSearchFilters.search;
        this.rightMatchService.checkModuleUrl();

        // check items list without selection
        this.rightMatchService.checkTotalItems();

        this.rightMatchService.getRightMatchList(true, null, this);

        this.rightMatchService.state.stateChanged$.subscribe(
            (res) => {
                if (res && res.refreshComponent) {
                    this.refreshList();
                }
                this.changeDetectorRef.markForCheck();
            }
        );

        this.subscriptions.add(this.translateService.onLangChange.subscribe(
            () => {
                this.rightMatchService.getRightMatchList(true, null, this);
            }
        ));

        this.blurSearchElement();
    }

    refreshList() {
        this.rightMatchService.getRightMatchList(true, null, this);
    }

    /**
     * Set search parameter on event from shared/main-list/component/mobile/mobile-main-list-search-bar
     * @param event
     */
    setSearchFilter(event: string): void {
        this.lastSearch = event;
        this.rightMatchService.setSearchFilter(event);
        this.refreshList();
        this.blurSearchElement();
    }

    /**
     * Remove focus from the search input
     */
    blurSearchElement() {
        let activeElement = document.activeElement as HTMLElement;
        activeElement.blur();

        // check the case when the button Search/Clear was clicked
        setTimeout(() => {
            if (document.activeElement.tagName === 'INPUT') {
                activeElement = document.activeElement as HTMLElement;
                activeElement.blur();
            }
        }, 0 );
    }

    createNewRightMatch() {
        this.addAnalysis = true;
    }

    backToItemsList() {
        this.router.navigate(['m/analysis/rightmatch/list', {cancel: true, moduleName: 'analysis'}]).then(() => {
            this.addAnalysis = false;
        });
    }

    /**
     * Order list rows on event from shared/main-list/component/main-list
     * @param event
     */
    setOrder(event) {
        this.rightMatchService.setOrder(event);
        this.refreshList();
    }

    /**
     * Set selected item on event from shared/main-list/component/mobile/mobile-main-list
     * @param item
     */
    itemSelected(item): void {
        this.closed = false;
        this.rightMatchService.state.lastSideBarStatus = 'reports';
        this.rightMatchService.itemSelected(item);
    }

    switchTab(index) {
        const tabName = this.analysisTabs.find((e, i) => {
            if (i === index) {
                return e;
            } else {
                return;
            }
        });
        this.router.navigate(['/m/analysis/' + tabName + '/list']).then(() => {
            this.selectedTab = index;
        });
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

}
